export default __webpack_public_path__ + "static/media/target-header-bg.aa591ca4.png";